function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2102 14.2105H21.3155C21.9668 14.2105 22.4997 13.6776 22.4997 13.0263C22.4997 12.375 21.9668 11.8421 21.3155 11.8421H14.2102C12.9076 11.8421 11.8418 12.9079 11.8418 14.2105V30.7895C11.8418 32.0921 12.9076 33.1579 14.2102 33.1579H21.3155C21.9668 33.1579 22.4997 32.625 22.4997 31.9737C22.4997 31.3224 21.9668 30.7895 21.3155 30.7895H14.2102V14.2105Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.2961 22.0856L32.9921 18.7816C32.9097 18.697 32.804 18.6389 32.6884 18.6147C32.5729 18.5906 32.4527 18.6014 32.3433 18.6459C32.234 18.6904 32.1404 18.7666 32.0745 18.8646C32.0087 18.9626 31.9736 19.078 31.9737 19.1961V21.3158H23.6842C23.0329 21.3158 22.5 21.8487 22.5 22.5001C22.5 23.1514 23.0329 23.6843 23.6842 23.6843H31.9737V25.804C31.9737 26.3369 32.6132 26.5974 32.9803 26.2185L36.2842 22.9145C36.5211 22.6895 36.5211 22.3106 36.2961 22.0856Z",
  fill: "white"
});
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 45,
    viewBox: "0 0 49 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/log out.41c2b91db7a1a3ab7e68c30a435fc64c.svg";
export { ForwardRef as ReactComponent };